/**
 *
 *
 */

import RiskFactor from './risk-factor';

export default class PaymentCard extends RiskFactor {
    static getCondition({billingAddress, paymentInstrument}) {
        return !!billingAddress && !!paymentInstrument && paymentInstrument.method === 'payment-card';
    }

    parse({billingAddress, paymentInstrument, paymentCard}) {
        this.billingAddress = billingAddress;
        this.paymentInstrument = paymentInstrument;
        this.paymentCard = paymentCard;
        if (this.billingAddress.country === null
            || this.paymentCard.bankCountry === null) {
            this.icon = 'dash-l';
            this.className = 'icon-yellow';
            this.result = 'Billing country and/or bank country is not available';
        } else if (this.billingAddress.country === this.paymentCard.bankCountry) {
            this.icon = 'check-s';
            this.className = 'icon-green';
            this.result = 'Billing country matches the bank country';
        } else {
            this.icon = 'close-s';
            this.className = 'icon-red';
            this.result = 'Billing country does not match the bank country';
        }
    }

    getResult() {
        return this.result;
    }
}
